export default "__VITE_ASSET__CcgdZUtW__"